module.exports = __webpack_public_path__ + "static/media/call.e72fd159.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/call.svg
// module id = 1655
// module chunks = 2